import React from 'react';
import {Modal} from 'react-bootstrap';

const DeleteAddressModal = (props)=>{
    const {emailAddress, onHide, onConfirm} = props;
    return (
        <Modal
            show={true}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar contacto</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar el contacto&nbsp;<strong>{emailAddress.name}</strong>?</p>
                <p>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( emailAddress ) }>Eliminar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteAddressModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/DeleteAddressModal/index.jsx